import theme from "../../styles/__theme";
import { keyframes } from "../../utils/barrels/emotion-react";
import { styled } from "../../utils/barrels/emotion-styled";

const { colors, spacing, fontSize } = theme;

export const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderContainer = styled.div`
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	background: ${colors.white};
	z-index: 9999;
`;

export const CircularLoader = styled.div`
	position: relative;
	width: 80px;
	height: 80px;
	margin-bottom: ${spacing.xLarge};
`;

export const SvgContainer = styled.svg`
	width: 80px;
	height: 80px;
	transform: rotate(-90deg);
`;

export const CircularTrack = styled.circle`
	fill: none;
	stroke: ${colors.lightGrey};
	stroke-width: 4;
`;

export const CircularProgress = styled.circle`
	fill: none;
	stroke: ${colors.purple};
	stroke-width: 4;
	stroke-linecap: round;
	stroke-dasharray: 188.4;
	stroke-dashoffset: 125.6;
	animation: ${spin} 1.5s linear infinite;
	transform-origin: 40px 40px;
`;

export const IconContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const LoadingText = styled.p`
	font-size: ${fontSize.large};
	color: ${colors.silverGrey};
	margin: 0;
	font-family: "Roboto", "Helvetica", "Arial", sans-serif;
	font-weight: 400;
`;
